import * as React from "react";
import { useMenuContext_unstable } from "@fluentui/react-components";
import type { MenuItemShimProps } from "./MenuItemShim";
import {
  useDispatchOptimizationEnabled,
  useTriggerOnMenuDismissedOnSubmenuClose,
} from "../../hooks/useNextComponentsEnabled";

export const CustomMenuItem = (menuItemShimProps: MenuItemShimProps) => {
  // Using the useMenuContext_unstable hook to dismiss the menu and it's children when a custom rendered item is executed.
  const setOpen = useMenuContext_unstable((context) => context.setOpen);

  const isDispatchOptimizationEnabled = useDispatchOptimizationEnabled();
  const triggerOnMenuDismissedOnSubmenuClose =
    useTriggerOnMenuDismissedOnSubmenuClose();

  if (isDispatchOptimizationEnabled || triggerOnMenuDismissedOnSubmenuClose) {
    return (
      <div
        onClick={
          menuItemShimProps.onDismiss?.length === 0
            ? undefined
            : (e) => {
                setOpen(e, {
                  open: false,
                  keyboard: undefined,
                  bubble: true,
                  type: "menuItemClick",
                  event: e,
                });
              }
        }
      >
        {menuItemShimProps.itemProps.onRender?.(
          menuItemShimProps.itemProps,
          menuItemShimProps.onDismiss ? menuItemShimProps.onDismiss : () => {}
        )}
      </div>
    );
  }

  return menuItemShimProps.itemProps.onRender?.(
    menuItemShimProps.itemProps,
    menuItemShimProps.onDismiss ? menuItemShimProps.onDismiss : () => {}
  );
};
